import { useMemo } from 'react';

import { KIT_PRICE, KIT_PRICE_LEGACY, KIT_PRICE_NO_SUBS } from 'assets';
import { urls } from '@repo/app-constants';
import { KitType } from '@repo/types';
import useSubscriptions from 'services/general/subscriptionsList';

interface UseCheckoutKitOptions {
  kitType?: KitType;
  nonMemberUrl?: string;
}

export const useCheckoutKit = (options?: UseCheckoutKitOptions) => {
  const { kitType, nonMemberUrl } = options || {};
  const { isAnyTinyPlus, isTinyPlus } = useSubscriptions();

  const checkoutUrl = useMemo(() => {
    // If nonMemberUrl is explicitly provided and user is not a member, use it
    if (nonMemberUrl && !isAnyTinyPlus) {
      return nonMemberUrl;
    }

    // Original logic for members and non-members (when nonMemberUrl not provided)
    if (kitType === KitType.VAGINAL) {
      return isAnyTinyPlus
        ? isTinyPlus
          ? urls.CHECKOUT_WITH_KIT_TINY_PLUS_VAGINAL
          : urls.CHECKOUT_WITH_KIT_TINY_PLUS_PROGRAM_OR_PROACTIVE_VAGINAL
        : urls.CHECKOUT_WITH_KIT_NON_TINY_PLUS_VAGINAL;
    } else {
      return isAnyTinyPlus
        ? isTinyPlus
          ? urls.CHECKOUT_WITH_KIT_TINY_PLUS
          : urls.CHECKOUT_WITH_KIT_TINY_PLUS_PROGRAM_OR_PROACTIVE
        : urls.CHECKOUT_WITH_KIT_NON_TINY_PLUS;
    }
  }, [kitType, isAnyTinyPlus, isTinyPlus, nonMemberUrl]);

  const price = useMemo(() => {
    if (!isAnyTinyPlus) {
      return KIT_PRICE_NO_SUBS;
    }

    return isTinyPlus ? KIT_PRICE_LEGACY : KIT_PRICE;
  }, [
    isAnyTinyPlus,
    isTinyPlus,
    KIT_PRICE,
    KIT_PRICE_LEGACY,
    KIT_PRICE_NO_SUBS,
  ]);

  return {
    checkoutUrl,
    price,
  };
};
export default useCheckoutKit;
